module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.city_title) ? _c('div', {
    staticClass: "row mena-contact-map"
  }, [_c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12"
  }, [(_vm.city_title) ? _c('div', {
    staticClass: "our-location__label"
  }, [_vm._v(_vm._s(_vm.city_title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "location-list"
  }, [_c('ul', _vm._l((_vm.cities), function(city, i) {
    return _c('li', {
      key: i,
      staticClass: "location-list__item",
      class: {
        'location-list__item--active': _vm.activeOffice === i
      },
      on: {
        "click": function($event) {
          return _vm.setActiveOffice(i, city.city)
        }
      }
    }, [_c('span', {
      staticClass: "location-list__item-text"
    }, [_vm._v(_vm._s(city && city.city) + ", " + _vm._s(city && city.country))]), _vm._v(" "), (_vm.activeOffice === i) ? _c('span', {
      staticClass: "location-list__item-arrow"
    }) : _vm._e()])
  }), 0)])]), _vm._v(" "), (_vm.cities[this.activeOffice]) ? _c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12 mena-contact-map__col-1",
    domProps: {
      "innerHTML": _vm._s(_vm.cities[this.activeOffice].adress)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.cities[this.activeOffice]) ? _c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12 mena-contact-map__col-2",
    domProps: {
      "innerHTML": _vm._s(_vm.cities[this.activeOffice].contact)
    }
  }) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd0193ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenaContactMap.vue
// module id = 369
// module chunks = 0